module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Burnley.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Burnley.png
// module id = 2183
// module chunks = 4